// eslint-disable-next-line no-restricted-imports
import { Form as AntForm } from 'antd';
import styled from 'styled-components';
import { DatePicker } from 'components/atoms/date-picker';
import {
  HelperText,
  Label,
  Label01,
  Outline,
  OutlineError,
} from 'components/styles';
import { Input } from '../input';
import { RichTextEditor } from '../rich-text-editor';
import { selectPrefix } from '../select';

export const RichTextareaEditor = styled(RichTextEditor)`
  && {
    --rte-background: var(--gray-10);
    border-bottom: solid 1px var(--gray-50);
    transition: all var(--animation-duration-slow);

    &:focus-within {
      border-bottom-color: transparent;
    }

    .ck-focused {
      ${Outline};
    }
  }
`;

export const StyledForm = styled(AntForm)`
  .ant-form-item {
    padding-bottom: var(--layout-01);
  }

  .ant-form-item-control-input {
    margin-bottom: var(--spacing-02);
  }

  .ant-form-item-has-error {
    ${Input}.ant-input-affix-wrapper,
    ${Input}.ant-input,
    .ant-input-number {
      ${OutlineError};
      &:focus {
        box-shadow: none;
        ${OutlineError};
      }
    }
    .ant-form-item-extra {
      display: none;
    }

    ${RichTextareaEditor} {
      border-bottom-color: transparent;

      .ck-editor__editable {
        ${OutlineError};
      }

      &:hover {
        --rte-background: var(--white-100);
      }
    }
  }

  .ant-form-item-has-feedback {
    .ant-input {
      padding-right: var(--input-height-default);
      &.ant-input-sm {
        padding-right: var(--input-size-sm);
      }
      &.ant-input-lg {
        padding-right: var(--input-height-lg);
      }
    }
    .ant-form-item-children-icon {
      width: var(--input-height-default);
    }
  }

  &.ant-form-small {
    .ant-form-item-has-feedback {
      .ant-form-item-children-icon {
        width: var(--input-size-sm);
      }
    }
  }

  &.ant-form-lg {
    .ant-form-item-has-feedback {
      .ant-form-item-children-icon {
        width: var(--input-height-lg);
      }
    }
  }

  .ant-form-item-label {
    ${Label};
  }
`;

const { Item } = AntForm;

const StyledItem = styled(Item)`
  .ant-form-item-label,
  .ant-form-item-label > label {
    ${Label};
    &.ant-form-item-required:not(.ant-form-item-required-mark-optional):before {
      ${Label01};
    }
  }

  .ant-form-item-explain,
  .ant-form-item-extra {
    ${HelperText};

    &.ant-form-item-explain-error {
      color: var(--error-color);
    }
  }

  &.ant-form-item-has-error {
    .${selectPrefix}__control {
      outline-color: var(--error-color) !important;
    }

    ${DatePicker} {
      outline-color: var(--error-color);
    }
  }
`;

type Form = typeof StyledForm & {
  Item: typeof StyledItem;
};

const Form: Form = StyledForm as any;

Form.Item = StyledItem;

export { Form };
